const questionStyle = {
  gridItem: {
    height: "calc(100vh - 49px)",
  },
  gridDescription: {
    padding: "10px",
    // borderRight: "1px solid gray",
    display: "flex",
    flexDirection: "column",
    height: "calc(100vh - 49px)",
    overflow: "auto !important"
  },
  questionBackButton: {
    float: "right",
    width: "fit-content"
  },
  questionDiv: {
    'overflow':'auto', 
    'height':'100%',
    'padding':'15px'
  },
  splitter: {
    height: "inherit !important"
  },
  backButton: {
    padding: "0 10px"
  }
};
  
export default questionStyle;